import React from "react";

const Pizza = (props) => {
  return (
    <div className="pizza" {...(props.soldout && "sold-out")}>
      <img src={props.photoName} alt={props.name} />
      <div>
        <h3>{props.name}</h3>
        <p>{props.ingredients}</p>
        <span>{props.price}</span>
      </div>
    </div>
  );
};

export default Pizza;
